import React from "react";
import { Link } from "react-router-dom";
import { Clock, ArrowRight } from "lucide-react";
import { usePageMeta } from "@/components/site/usePageMeta";
import { PageHero } from "@/components/site/PageHero";
import { Reveal } from "@/components/site/useReveal";
import { ContactSection } from "@/components/site/ContactSection";
import { POSTS } from "@/components/site/blogData";
import { ROUTES } from "@/components/site/data";

export default function BlogPage() {
  usePageMeta(
    "Blog | Wallstreet Realty",
          "Straight answers on buying, selling, financing, and building a real estate career in Southern California, from the Wallstreet Realty team."
  );
  return (
    <>
      <PageHero
        crumb="Blog"
        eyebrow="Insights"
        title="Southern California Real Estate, Explained"
                subtitle="Practical guides for buyers, sellers, and agents, written by the team that lives these transactions every day."
        ctas={[
          { label: "Search Homes", href: ROUTES.idx, testid: "blog-hero-search" , pill: true},
          { label: "Ask Us a Question", href: ROUTES.contact, variant: "outline", testid: "blog-hero-contact" },
        ]}
      />

      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid sm:grid-cols-2 gap-6">
            {POSTS.map((post, i) => (
              <Reveal key={post.slug} delay={i * 60}>
                <Link
                  to={`${ROUTES.blog}/${post.slug}`}
                  data-testid={`blog-card-${post.slug}`}
                  className="lift group flex flex-col h-full bg-[#F5F5F5] border border-[#E5E5E5] rounded-[20px] overflow-hidden hover:border-[#C9A961]"
                >
                  <div className="h-52 overflow-hidden">
                    <img
                      src={post.image}
                      alt={post.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                  </div>
                  <div className="flex flex-col flex-1 p-7">
                    <div className="flex items-center gap-3 text-xs">
                      <span className="text-[#C9A961] font-heading font-bold uppercase tracking-[0.15em]">{post.category}</span>
                      <span className="inline-flex items-center gap-1 text-[#2D2D37]/45">
                        <Clock size={12} /> {post.readMins} min read
                      </span>
                    </div>
                    <h2 className="mt-3 font-heading font-bold text-xl leading-snug text-[#2D2D37] group-hover:text-[#254369]">
                      {post.title}
                    </h2>
                    <p className="mt-3 text-sm leading-relaxed text-[#2D2D37]/65 flex-1">{post.excerpt}</p>
                    <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-[#254369] group-hover:text-[#C9A961] transition-colors">
                      Read Article <ArrowRight size={15} />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <ContactSection />
    </>
  );
}
